<template>
  <SimpleStackedChart
    :name="$t('Chart__GeneralAndSpecialistDoctors__name')"
    :sheets="sheets"
    :height="500"
  />
</template>

<script>
import data from '@/assets/json/GeneralAndSpecialistDoctors.json';
import SimpleStackedChart from '@/components/ChartPartials/SimpleStackedChart';

export default {
  name: 'GeneralAndSpecialistDoctors',
  components: {
    SimpleStackedChart
  },
  data() {
    return {
      sheets: data
    };
  }
};
</script>

<style scoped></style>
